import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { Label, type LabelProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Label), _mergeProps({ "data-slot": "label" }, delegatedProps.value, {
    class: 
            _unref(cn)(
                'flex items-center gap-2 text-xs leading-none font-medium select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})